import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "资格证书正面 ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "资格证书背面", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "   补充资料   ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import formattingText from "@/components/view/formattingText.vue";
import {ref} from 'vue'
import STATUS from "@/components/model/enum"
import {getDate} from '@/components/ts/components';
import fallBackimage from '../../assets/images/fallBackImage.png'
import FormattingText from "@/components/view/formattingText.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DoctorView',
  props: {
  doctorInfo: {
    type: Object,
    default: function () {
      return {}
    }
  }
},
  setup(__props) {

const prop = __props;

const getPic = (type: string)=>{
    let pic: any[] =  prop.doctorInfo.docs && prop.doctorInfo.docs.length > 0?prop.doctorInfo.docs.filter((e: any)=>{
        return e.type === type
    }):[];
    return pic.length>0?pic[0].path.split('?')[0]:fallBackimage
}





return (_ctx: any,_cache: any) => {
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 4 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_image, {
              width: 200,
              height: 200,
              preview: false,
              src: getPic('AVATAR'),
              fallback: _unref(fallBackimage)
            }, null, 8, ["src", "fallback"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(formattingText, {
              leftText: "姓名",
              rightText: __props.doctorInfo.name
            }, null, 8, ["rightText"]),
            _createVNode(formattingText, {
              leftText: "生日",
              rightText: __props.doctorInfo.born?_unref(getDate)(__props.doctorInfo.born):''
            }, null, 8, ["rightText"]),
            _createVNode(formattingText, {
              leftText: "性别",
              rightText: _unref(STATUS)('genderType').getDesc(__props.doctorInfo.gender)
            }, null, 8, ["rightText"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(formattingText, {
              leftText: "手机号",
              rightText: __props.doctorInfo.mobile
            }, null, 8, ["rightText"]),
            _createVNode(formattingText, {
              leftText: "邮箱",
              rightText: __props.doctorInfo.email
            }, null, 8, ["rightText"]),
            _createVNode(formattingText, {
              leftText: "职位",
              rightText: _unref(STATUS)('levelType').getDesc(__props.doctorInfo.level)
            }, null, 8, ["rightText"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _hoisted_1,
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 8 }, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3,
            _createVNode(_component_a_image, {
              width: 200,
              height: 200,
              preview: true,
              src: getPic('DENTIST_LICENSE_FRONT'),
              fallback: _unref(fallBackimage)
            }, null, 8, ["src", "fallback"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 8 }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5,
            _createVNode(_component_a_image, {
              width: 200,
              height: 200,
              preview: true,
              src: getPic('DENTIST_LICENSE_BACK'),
              fallback: _unref(fallBackimage)
            }, null, 8, ["src", "fallback"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 8 }, {
          default: _withCtx(() => [
            _hoisted_6,
            _hoisted_7,
            _createVNode(_component_a_image, {
              width: 200,
              height: 200,
              preview: true,
              src: getPic('DENTIST_DOCUMENT'),
              fallback: _unref(fallBackimage)
            }, null, 8, ["src", "fallback"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})